document.addEventListener("DOMContentLoaded", function() {
    const productTemplate = document.querySelectorAll('.product-single');

    if(productTemplate && productTemplate.length) {

        var PhotoSwipe = themePhotoswipe.PhotoSwipe.default,
            PhotoSwipeUI_Default = themePhotoswipe.PhotoSwipeUI.default,
            pswpElement = document.querySelectorAll('.pswp')[0];

        /*
        PhotoSwipe can't hook into an instanced Slider, but creating a new one overwrites the existing slider
        We're creating a new Photoswipe every time a product .product-single__media-slide is clicked, to load only current color
        */
        const productSingleMediaSlides = document.querySelectorAll('.product-single__media-slide a');
        productSingleMediaSlides.forEach(function(slide, i) {
            slide.addEventListener('click', function(e, slidei) {
                e.preventDefault();

                // create slider only from elements with "current color" class
                var galleryItems    = document.querySelectorAll('.product-single__media-slide.current-color'),
                    itemsArray = [];

                galleryItems.forEach(function(item) {
                    itemLink = item.querySelector('a');
                    itemsArray.push({
                        src:    itemLink.href,
                        h:      itemLink.dataset.imageHeight,
                        w:      itemLink.dataset.imageWidth,
                    });
                });

                // init slider
                var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, itemsArray);
                gallery.init();
                const pswpElements = document.querySelectorAll('.pswp');
            });
    });
    }
});

// close button functionality sometimes glitches and pswp stays visible, so we're forcing it to close
const pswpClose = document.querySelectorAll('.pswp__button--close');
if(pswpClose && pswpClose.length) {
    pswpClose.forEach(function(button) {
        button.addEventListener('click', function() {
            const pswpElements = document.querySelectorAll('.pswp');
            pswpElements.forEach(function(element) {
                element.classList.remove('pswp--open');
            });
        });
    });

}

